import React, { PropTypes, PureComponent } from 'react';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';
import { connect } from 'react-redux';

import { Leave } from './leave/main';
import { Unavailable } from './unavailable/main';
import { ConfirmTimeoff } from './confirmation/main';

import { Button, Messagebar } from '../../../shared';

import statsd from '../../../../lib/StatsD';

import './styles.scss';

const ACTIVITY_TIMEOUT = 30000;

export class Requests extends PureComponent {
  constructor(props) {
    super(props);
    this.showConfirm = this.showConfirm.bind(this);

    // decide on which tab to show by default
    // we can't get to this page if these aren't set
    const activeTab = props.features.leave.value ? 'leave' : 'unavailable';

    this.state = {
      confirm: false,
      tab: activeTab,
    };
  }

  componentDidMount() {
    this.props.setAndStartTimer(ACTIVITY_TIMEOUT);
  }

  changeTab(newTab) {
    statsd.increment(`leave.change_tab.${newTab}`);
    this.setState({ tab: newTab });
  }

  removeNotifications() {
    if (this.props.notifications.length > 0) {
      this.props.clearNotifications();
    }
  }

  showTab() {
    switch (this.state.tab) {
      case 'unavailable':
        return (<Unavailable
          {...this.props}
          parentInteract={this.props.setAndStartTimer}
          showConfirm={this.showConfirm}
        />);
      case 'leave':
      default:
        return (<Leave
          {...this.props}
          showConfirm={this.showConfirm}
          parentInteract={this.props.setAndStartTimer}
        />);
    }
  }

  showConfirm() {
    this.setState({ confirm: true });
  }

  showLeave() {
    if (this.props.features.leave.value === false) {
      return null;
    }
    return (
      <Button
        className={`timeoff-tab ${this.state.tab === 'leave'}`}
        onClick={() => this.changeTab('leave')}
      >
        <p><i className="fa fa-plus" aria-hidden="true" />
        Add Leave Request
        </p>
      </Button>
    );
  }

  showUnavail() {
    if (this.props.features.unavailability.value === false) {
      return null;
    }
    return (
      <Button
        className={`timeoff-tab ${this.state.tab === 'unavailable'}`}
        onClick={() => this.changeTab('unavailable')}
      >
        <p><i className="fa fa-plus" aria-hidden="true" />
        Add Unavailability
        </p>
      </Button>
    );
  }

  renderNotification() {
    if (this.props.notifications.length > 0) {
      const notification = this.props.notifications[0];
      return (
        <Messagebar
          index={0} // in the future, this should be the actual message index
          className="Auth__notification"
          remove={this.props.removeNotification}
          {...notification}
        />
      );
    }

    return null;
  }

  renderConfirm() {
    if (this.state.confirm) {
      this.props.setAndStartTimer(4000);
      return <ConfirmTimeoff {...this.props} />;
    }
    return null;
  }


  render() {
    return (
      <div
        className='timeoff'
        onClick={() => {
          this.props.setAndStartTimer(ACTIVITY_TIMEOUT);
          this.removeNotifications();
        }}
      >
        {this.renderNotification()}
        <ReactCSSTransitionGroup
          component='div'
          className='animationBlock'
          transitionName='fade'
          transitionAppear={false}
          transitionEnter
          transitionLeave
          transitionEnterTimeout={500}
          transitionLeaveTimeout={500}
        >
          {this.renderConfirm()}
        </ReactCSSTransitionGroup>

        <div className='timeoff-tabs'>
          {this.showLeave()}
          {this.showUnavail()}
        </div>

        {this.showTab()}

      </div>
    );
  }
}

export default connect(state => ({
  notifications: state.getIn(['messages', 'notifications']).toJS(),
}))(Requests);

Requests.propTypes = {
  notifications: PropTypes.array,
  features: PropTypes.object,
  removeNotification: PropTypes.func,
  clearNotifications: PropTypes.func,
  clearUser: PropTypes.func,
  setAndStartTimer: PropTypes.func,
};



// WEBPACK FOOTER //
// ./src/components/timeclock/userhub/requests/main.jsx